import React from 'react';
import {TablePagination} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import makeStyles from "@material-ui/core/styles/makeStyles";
import ScreenDesignerListHoc from "../../../../../../../../../HocHelpers/ScreenDesignerListHoc";

const useStyles = makeStyles(() => ({
    tableFooterWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minHeight: 40,
        height: 40,
    },
    toolBarPagination: {
        height: 30,
        minHeight: 30
    },
    paginationAction: {
        height: 30,
        flexShrink: 0,
        display: 'flex'
    },
    buttonChangePage: {
        padding: 0
    },
    currentPage: {
        alignSelf: 'center',
        fontSize: '0.75rem'
    },
    rowsPerPageRoot: {
        margin: '0px 6px 0 4px'
    },
    select: {
        paddingLeft: 0,
        fontSize: '0.75rem'
    },
    countingWrapper: {
        flexGrow: 1,
        display: 'flex',
        paddingLeft: 9
    },
    menuItem: {
        padding: '3px 5px'
    },
    caption: {
        fontSize: '0.75rem'
    }
}));

const TableFooterList = (props) => {
    const {
        data,
        page,
        rowsPerPage,
        rowsPerPageOptions,
    } = props;
    const classes = useStyles();
    return (
        <div className={classes.tableFooterWrapper}>
            <TablePagination
                count={data.totalElements}
                component={"div"}
                rowsPerPageOptions={rowsPerPageOptions}
                page={page}
                rowsPerPage={rowsPerPage}
                classes={{
                    toolbar: classes.toolBarPagination,
                    caption: classes.caption,
                    selectRoot: classes.rowsPerPageRoot,
                    select: classes.select,
                    menuItem: classes.menuItem
                }}
                SelectProps={{
                    disabled: true,
                    inputProps: {'aria-label': 'Rows Per Page'},
                    native: false,
                }}
                onChangePage={() => {}}
                labelRowsPerPage={'Size'}
                ActionsComponent={() => <TablePaginationActions/>}
                backIconButtonProps={{
                    'aria-label': 'previous page',
                }}
                nextIconButtonProps={{'aria-label': 'next page'}}
            />
        </div>
    )
};

export default ScreenDesignerListHoc(TableFooterList);

const TablePaginationActions = () => {
    const classes = useStyles();
    return (
        <div className={classes.paginationAction}>
            <IconButton
                disabled={true}
                className={classes.buttonChangePage}
                aria-label="first page"
            >
                <FirstPageIcon/>
            </IconButton>
            <IconButton
                disabled={true}
                className={classes.buttonChangePage}
                aria-label="previous page">
                <KeyboardArrowLeft/>
            </IconButton>
            <span className={classes.currentPage}>0</span>
            <IconButton
                disabled={true}
                className={classes.buttonChangePage}
                aria-label="next page"
            >
                <KeyboardArrowRight/>
            </IconButton>
            <IconButton
                disabled={true}
                className={classes.buttonChangePage}
                aria-label="last page"
            >
                <LastPageIcon/>
            </IconButton>
        </div>
    );
};